<div class="c-user-notification-item flex flex-col gap-3">
	@let currentNotification = notification();
	@if (currentNotification) {
		<div class="flex gap-1">
			<ui-tag
				[text]="(currentNotification.created_at | customDate: 'UTC') ?? ''"
				[type]="currentNotification.read ? 'secondaryLight' : 'dark'"
			></ui-tag>
			@if (!currentNotification.read) {
				<ui-tag [text]="'notifications.new' | translate" type="dark"></ui-tag>
			}
		</div>
		<div class="flex gap-2 items-center cursor-pointer" (click)="toggleExpand()">
			<ui-button
				type="link-dark"
				icon="x_arrow_down"
				[class]="isExpanded() ? 'rotate-180 transition-all' : 'rotate-0 transition-all'"
			></ui-button>

			<ui-headline type="h4" class="block" [noPadding]="true">
				{{ currentNotification.title | langValue }}
			</ui-headline>
		</div>
		<div
			class="c-notification__notificationText"
			[innerHTML]="currentNotification.content | langValue | trusted"
			[hidden]="!isExpanded()"
		></div>
	}
</div>
